export const STRIPE_URL = null;
export const initiateCheckout = () => {}; // Deprecated - use useCheckout hook

// Mock data - OpenBro - Musculation, Réseaux Sociaux, Contenu Vidéo, IA, Nutrition

export const navLinks = [
  { label: 'Accueil', href: '#' },
  { label: 'Formations', href: '#professions' },
  { label: 'Témoignages', href: '#reviews' },
  { label: 'Méthode', href: '#information' },
  { label: 'Campus', href: '#campus', overlay: true },
];

export const professorsData = [
  {
    codename: 'Agent Shadow',
    campus: 'Musculation & Discipline',
    image: 'https://images.pexels.com/photos/16886371/pexels-photo-16886371.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    achievements: ['+15 ans d\'expérience', 'Champion régional powerlifting', '3 000+ élèves transformés'],
  },
  {
    codename: 'Agent Cipher',
    campus: 'Réseaux Sociaux & E-commerce',
    image: 'https://images.unsplash.com/photo-1769636929231-3cd7f853d038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBwb3J0cmFpdCUyMGhlYWRzaG90JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzczMjMxMjA2fDA&ixlib=rb-4.1.0&q=85',
    achievements: ['2.5M+ followers cumulés', '800K€ CA e-commerce', 'Ex-consultant Meta Ads'],
  },
  {
    codename: 'Agent Phantom',
    campus: 'Création de Contenu Vidéo',
    image: 'https://images.unsplash.com/photo-1758534063829-a72058381e21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBwb3J0cmFpdCUyMGhlYWRzaG90JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzczMjMxMjA2fDA&ixlib=rb-4.1.0&q=85',
    achievements: ['150M+ vues TikTok', 'Créateur YouTube 500K subs', 'Formateur vidéo certifié'],
  },
  {
    codename: 'Agent Ghost',
    campus: 'Montage Vidéo Pro',
    image: 'https://images.unsplash.com/photo-1765776830139-72b2184dae5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBwb3J0cmFpdCUyMGhlYWRzaG90JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzczMjMxMjA2fDA&ixlib=rb-4.1.0&q=85',
    achievements: ['Monteur pour influenceurs 1M+', 'Expert DaVinci & Premiere', '500+ projets livrés'],
  },
  {
    codename: 'Agent Neural',
    campus: 'IA & Automatisation',
    image: 'https://images.pexels.com/photos/16886373/pexels-photo-16886373.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    achievements: ['Ingénieur IA ex-startup', '200+ workflows automatisés', 'Consultant GPT Enterprise'],
  },
  {
    codename: 'Agent Apex',
    campus: 'Nutrition & Performance',
    image: 'https://images.unsplash.com/photo-1767175620484-1ed37931a0d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBwb3J0cmFpdCUyMGhlYWRzaG90JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzczMjMxMjA2fDA&ixlib=rb-4.1.0&q=85',
    achievements: ['Nutritionniste diplômé', 'Coach d\'athlètes pro', 'Auteur best-seller nutrition'],
  },
];

export const heroData = {
  brandName: 'OPENBRO',
  headline: 'TU VIENS DE TROUVER LE SYSTÈME',
  subtitle1: 'Celui que <strong>99% des gens</strong> ne connaîtront jamais.',
  subtitle2: {
    before: 'Le blueprint exact pour transformer ton ',
    bold1: 'CORPS',
    mid1: ', ton ',
    bold2: 'CONTENU',
    mid2: ' et tes ',
    bold3: 'REVENUS.',
  },
  videoThumbnail: 'https://customer-29d3r31yjz332bf4.cloudflarestream.com/299162c521d3029e9cef2f27ee28fcea/thumbnails/thumbnail.jpg?height=720',
  ctaText: 'Rejoins Maintenant',
  enrolledText: '1 500+ Membres Actifs',
  enrolledAvatars: 'https://www.university.com/_next/image?url=%2Fenrolled.png&w=256&q=75',
};

export const statsData = [
  { value: '1 500+', label: 'Membres Actifs' },
  { value: '6', label: 'Formations Complètes' },
  { value: '92%', label: 'Taux de Transformation' },
];

export const takeActionData = {
  label: 'PASSE À L\u2019ACTION',
  title: 'L\u2019École Ne T\u2019Apprend Rien D\u2019Utile',
  paragraphs: [
    { text: '<strong>OPENBRO</strong> met à jour ses formations <strong>chaque semaine</strong> avec les dernières stratégies.' },
    { text: 'Accès immédiat à des <mark>méthodes testées et prouvées.</mark>' },
    { text: 'Musculation, nutrition, IA, montage vidéo — on t\u2019enseigne <strong>ce qui compte en 2025.</strong>' },
    { text: 'Nos formateurs sont des <strong>experts terrain</strong>, pas des théoriciens.' },
    { text: 'Tous nos membres <mark>voient des résultats dès le premier mois.</mark>' },
  ],
  phonesImage: 'https://customer-assets.emergentagent.com/job_2a07443c-5bc5-4457-afbd-a5d4dc6c062c/artifacts/u4v0d9f9_ip.png',
  underline2: 'https://www.university.com/_next/image?url=%2Funderline_2.png&w=384&q=75',
};

export const campusesData = {
  label: 'ACCÈDE À 6+ FORMATIONS',
  title: 'Ce Que Tu Vas Apprendre',
  campuses: [
    {
      name: 'Musculation & Discipline',
      image: 'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/38gaug6t_Upscaled%20Image%20%287%29.png',
      lucideIcon: 'Dumbbell',
      description: 'Programmes d\u2019entraînement structurés, <strong>discipline quotidienne</strong>, mindset de champion. Transforme ton physique et ta mentalité en <strong>moins de 90 jours.</strong>',
    },
    {
      name: 'Réseaux Sociaux & E-commerce',
      image: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/1sses6ae_Upscaled%20Image%20%286%29.png',
      lucideIcon: 'ShoppingBag',
      description: '<strong>Monétise ta présence en ligne.</strong> Apprends à créer une audience, lancer un e-commerce et <strong>générer des revenus récurrents</strong> depuis ton téléphone.',
    },
    {
      name: 'Création de Contenu Vidéo',
      image: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/i27uci5a_Upscaled%20Image%20%283%29.png',
      lucideIcon: 'Video',
      description: 'Scripte, filme et publie du contenu qui explose. Maîtrise les formats courts, les hooks et <strong>les algorithmes pour devenir viral.</strong>',
    },
    {
      name: 'Montage Vidéo Pro',
      image: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/4b1wj2x4_Upscaled%20Image%20%282%29.png',
      lucideIcon: 'Clapperboard',
      description: 'DaVinci, Premiere, CapCut — <strong>maîtrise les outils pro.</strong> Apprends le montage dynamique, les transitions, le sound design et le color grading.',
    },
    {
      name: 'IA & Automatisation',
      image: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/5m8ob6w8_Upscaled%20Image%20%285%29.png',
      lucideIcon: 'Bot',
      description: '<strong>Automatise ton business</strong> avec l\u2019IA. ChatGPT, agents IA, workflows automatisés — gagne du temps et <strong>multiplie tes résultats.</strong>',
    },
    {
      name: 'Nutrition & Performance',
      image: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/oyz55eql_Upscaled%20Image%20%284%29.png',
      lucideIcon: 'Apple',
      description: 'Plans nutritionnels personnalisés, supplémentation intelligente, optimisation du sommeil. <strong>Maximise ton énergie</strong> et ta récupération.',
    },
  ],
};

export const customPlatformData = {
  title: 'Une Plateforme\\nSur-Mesure',
  description: 'Notre application d\u2019apprentissage est conçue pour <mark>garantir ta transformation.</mark>',
  bgImage: '/laptops.png',
};

export const empoweringData = {
  label: 'OPENBRO',
  title: '1 500+ Membres Transformés Et Ce N\u2019Est Que Le Début',
  videoThumbnail: 'https://customer-assets.emergentagent.com/job_2a07443c-5bc5-4457-afbd-a5d4dc6c062c/artifacts/mnyrym2m_GOT.png',
  testimonialName: 'Mathis R. - Transformation 90 Jours',
  testimonialEarning: '-15kg / +Business en ligne',
  flagIcon: 'https://www.university.com/_next/image?url=%2Fflag_usa.png&w=48&q=75',
  description: 'Chez OpenBro, tu apprends <strong>les compétences qui comptent vraiment</strong> ; entouré de <strong>1 500+ personnes</strong> déterminées à <mark>transformer leur corps, leur contenu et leur vie.</mark>',
};

export const featuresData = [
  {
    title: 'Discipline = Liberté',
    points: [
      'Programmes de musculation et routines quotidiennes structurées.',
      'Du physique de débutant au physique de guerrier en 90 jours.',
      'Nutrition optimisée pour la performance maximale.',
    ],
    bgImage: 'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/26aku3w4_App%20Checklist%20Courses%202.png',
    dark: true,
    imageRight: true,
  },
  {
    title: 'Contenu Qui Explose',
    points: [
      'Création vidéo et montage pro — du script au publish.',
      'Maîtrise des algorithmes TikTok, Instagram, YouTube.',
      'Monétise ton audience avec l\u2019e-commerce et les partenariats.',
    ],
    bgImage: 'https://www.university.com/_next/image?url=%2Fround_tile_3.png&w=1920&q=75',
    dark: true,
    imageRight: false,
  },
  {
    title: 'IA & Automatisation',
    points: [
      'Utilise l\u2019IA pour automatiser ton business et ton contenu.',
      'Workflows intelligents qui travaillent pendant que tu dors.',
      'Support 24/7 de nos mentors experts en tech.',
    ],
    bgImage: 'https://www.university.com/_next/image?url=%2Fround_tile_1.png&w=1920&q=75',
    dark: true,
    imageRight: true,
  },
];

export const twoPathsData = {
  label: 'CHOISIS TON CHEMIN',
  title: 'Deux Chemins S\u2019Offrent À Toi',
  path1: {
    price: '5 ANS+',
    description: 'Continue à scroller <strong>sans rien changer.</strong> Même physique, même routine, même résultat. <strong>Le temps passe</strong> et rien ne bouge.',
    cta: 'Rester Spectateur',
    link: 'https://www.netflix.com',
  },
  path2: {
    price: '49€/mois',
    description: 'Accède immédiatement à <strong>6 formations complètes.</strong> Musculation, contenu vidéo, IA, nutrition — tout pour avancer plus vite et <mark>gagner plus.</mark>',
    cta: 'Rejoins Maintenant',
    link: 'https://checkout.stripe.com/c/pay/cs_live_a1rSkrK0YrEl9YZRqh6dvTtKV9xyW8KqiIkXvc3DM7ALMNKdulo0XDBWGG#fidnandhYHdWcXxpYCc%2FJ2FgY2RwaXEnKSdkdWxOYHwnPyd1blppbHNgWjA0SzQzYlRANnRSd2Y8bW1Uaz1paGhjbU1uTkRxVUwxSWdJf0FMMU1RQUNUbkAxfUx%2FajFyPU1sYGNHdlBEcjFUfUZfdG5JVmh9S25hdDBXaDRTVUJKUW5RNTVibmlVSV9oNCcpJ2N3amhWYHdzYHcnP3F3cGApJ2dkZm5id2pwa2FGamlqdyc%2FJyZjY2NjY2MnKSdpZHxqcHFRfHVgJz8ndmxrYmlgWmxxYGgnKSdga2RnaWBVaWRmYG1qaWFgd3YnP3F3cGB4JSUl',
  },
  vsIcon: 'https://www.university.com/_next/image?url=%2Fvs.png&w=256&q=75',
  arrowsImage: 'https://www.university.com/_next/image?url=%2Farrows_mobile.png&w=640&q=75',
};

export const studentWinsData = {
  label: 'RÉSULTATS MEMBRES',
  title: 'Transformations Réelles',
  subtitle: 'On t\u2019a dit que le changement prend des années.',
  subtitleBold: 'Nos membres <mark>prouvent le contraire</mark> chaque jour.',
  wins: [
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/ndrbybe3_Editor%20result.jpg',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/8y30a51x_D37DF64E-36E3-4DBC-8289-1086C70815BC.JPG',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/iq1chxmj_IMG_0081.jpeg',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/6p234650_Upscaled%20Image%20%2817%29.png',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/80fid9es_IMG_0069.JPG',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/8s2eaj19_1B970E81-CC14-4905-94E8-E0B7D86EE804.JPG',
    'https://customer-assets.emergentagent.com/job_web-redesign-section/artifacts/ig0etuo3_IMG_9147.JPG',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/m2h0e9p8_F8F2F79B-6F60-457D-9852-51D273A3B790.JPG',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/l4phm9hs_IMG_0075.jpg',
    'https://customer-assets.emergentagent.com/job_web-redesign-section/artifacts/9i5cr73x_IMG_9144.JPG',
    'https://customer-assets.emergentagent.com/job_web-redesign-section/artifacts/a0ilxnm5_IMG_9143.JPG',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/xx9vbzlh_5808BA6E-E27A-42AD-AAEB-5D15751A1EB7.JPG',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/1q26xu2g_66C70A90-1B49-4F56-B367-3A4B5E9FD7A5.JPG',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/l0xhbq09_IMG_0093.JPG',
    'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/z7vlo947_Transformation%202%20mois%203.png',
  ],
};

export const lastChanceData = {
  title: 'C\u2019Est Maintenant Ou Jamais !',
  cta: 'Rejoins Maintenant',
  subtitle: 'Places Limitées',
  bgImage: 'https://www.university.com/_next/image?url=%2Frectangle.png&w=3840&q=75',
  logo: 'https://www.university.com/_next/image?url=%2Flogo.png&w=48&q=75',
};

export const faqData = {
  title: 'Questions Fréquentes',
  disclaimer1: 'Tout le contenu enseigné au sein d\u2019OpenBro est à but éducatif. C\u2019est à chaque membre d\u2019appliquer et de fournir le travail nécessaire.',
  disclaimer2: 'L\u2019équipe OpenBro ne garantit aucun résultat physique ou financier spécifique.',
  questions: [
    {
      question: 'Je suis débutant en musculation, c\u2019est un problème ?',
      answer: 'Absolument pas ! Nos programmes sont conçus du niveau zéro jusqu\u2019au niveau avancé. Tu seras guidé étape par étape avec des vidéos détaillées et un suivi personnalisé.',
    },
    {
      question: 'J\u2019ai besoin de matériel spécifique ?',
      answer: 'Non. Nos programmes s\u2019adaptent à ta situation — en salle ou à la maison. Pour le contenu vidéo, un smartphone suffit pour commencer. On t\u2019apprend à faire du pro avec le minimum.',
    },
    {
      question: 'Je n\u2019y connais rien en montage vidéo ou en IA.',
      answer: 'C\u2019est justement pour ça qu\u2019on est là. Nos formations partent de zéro. Tu apprends les bases puis tu montes en compétences rapidement avec des exercices pratiques.',
    },
    {
      question: 'Combien de temps par jour faut-il consacrer ?',
      answer: '30 minutes minimum. Nos méthodes sont conçues pour être efficaces et rapides. En 30 min de muscu + 30 min de formation contenu, tu progresses chaque jour.',
    },
    {
      question: 'Est-ce que ça marche vraiment pour le e-commerce ?',
      answer: 'Oui. Nos membres génèrent des revenus réels grâce aux stratégies enseignées. Tu apprends à créer un business en ligne, gérer tes réseaux sociaux et monétiser ton audience.',
    },
    {
      question: 'Les formations sont-elles mises à jour ?',
      answer: 'Absolument. L\u2019IA évolue chaque mois, les algorithmes changent — nos formations sont mises à jour en continu pour rester à la pointe.',
    },
    {
      question: 'J\u2019accède à tout dès l\u2019inscription ?',
      answer: 'Oui ! Dès ton inscription, tu as accès aux 6 formations complètes : Musculation, Réseaux sociaux, Contenu vidéo, Montage, IA et Nutrition. Plus le réseau privé de 1 500+ membres.',
    },
    {
      question: 'Encore des questions ?',
      answer: 'Clique sur le chat en bas à droite. Notre équipe répond en moins de 24h à toutes tes questions.',
    },
  ],
};

export const assets = {
  logo: 'https://www.university.com/_next/image?url=%2Flogo.png&w=48&q=75',
  underline: 'https://www.university.com/_next/image?url=%2Funderline.png&w=1920&q=75',
  arrowLeft: 'https://www.university.com/_next/image?url=%2Farrow_left.png&w=256&q=75',
  arrowRight: 'https://www.university.com/_next/image?url=%2Farrow_right.png&w=256&q=75',
  statsBackground: 'https://www.university.com/_next/image?url=%2Frect_text.png&w=3840&q=75',
  bgAlt: 'https://www.university.com/bg_altsection2.png',
  enrolledAvatars: 'https://www.university.com/_next/image?url=%2Fenrolled.png&w=256&q=75',
  phonesImage: 'https://customer-assets.emergentagent.com/job_2a07443c-5bc5-4457-afbd-a5d4dc6c062c/artifacts/u4v0d9f9_ip.png',
  underline2: 'https://www.university.com/_next/image?url=%2Funderline_2.png&w=384&q=75',
  videoThumbnail: 'https://customer-29d3r31yjz332bf4.cloudflarestream.com/299162c521d3029e9cef2f27ee28fcea/thumbnails/thumbnail.jpg?height=720',
  empoweringVideoThumbnail: 'https://customer-29d3r31yjz332bf4.cloudflarestream.com/f336eab3beef170cc27b4a1370e33acc/thumbnails/thumbnail.jpg?height=720',
  lastChanceBg: 'https://www.university.com/_next/image?url=%2Frectangle.png&w=3840&q=75',
  vsIcon: 'https://www.university.com/_next/image?url=%2Fvs.png&w=256&q=75',
  arrowsMobile: 'https://www.university.com/_next/image?url=%2Farrows_mobile.png&w=640&q=75',
};
